<template>

  <div class="LoginModulo" :class="{ 'mobile': isMobile() }">

    <!-- Dialog di modifica Password Temporanea -->
    <el-dialog :title="($t('login.editPwd').toUpperCase())" :visible.sync="showModalPwd"
      :class="isMobile() ? 'el-dialog_mobile' : 'custom-dialog'" :append-to-body="true"
      :custom-class="isMobile() ? 'col-24' : 'offset-7 col-10'" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false">

      <el-form class="" v-if="isMobile()">
        <!--<div class="form-profilo">-->
        <div class="elemento row row-custom">
          <div class="my-label col-24 no-padding">
            {{ $t('login.username') }}
          </div>
          <div class="my-value col-24 no-padding">
            <el-input placeholder="" v-model="loginForm.username" disabled></el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-24 no-padding">
            {{ $t('login.passwordTmp') }}
          </div>
          <div class="my-value col-24 no-padding">
            <el-input placeholder="" v-model="pwdForm.oldPwd" type="password" clearable autocomplete="off"></el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-24 no-padding">
            {{ $t('login.passwordNew') }}
          </div>
          <div class="my-value col-24 no-padding">
            <el-input placeholder="" v-model="pwdForm.newPwd" type="password" clearable autocomplete="off"></el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-24 no-padding">
            {{ $t('login.passwordRep') }}
          </div>
          <div class="my-value col-24 no-padding">
            <el-input placeholder="" v-model="pwdForm.newPwdRep" type="password" clearable
              autocomplete="off"></el-input>
          </div>
        </div>
        <!--</div>-->

      </el-form>

      <el-form class="" v-else>
        <!--<div class="form-profilo">-->
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('login.username') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="loginForm.username" disabled></el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('login.passwordTmp') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="pwdForm.oldPwd" type="password" clearable autocomplete="off"></el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('login.passwordNew') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="pwdForm.newPwd" type="password" clearable autocomplete="off"></el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('login.passwordRep') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="pwdForm.newPwdRep" type="password" clearable
              autocomplete="off"></el-input>
          </div>
        </div>
        <!--</div>-->

      </el-form>

      <span slot="footer" class="">
        <div class="col-24 no-padding">
          <el-button class="WEB-button WEB-button-primary" @click="changePwd">
            {{ $t('btn.salva').toUpperCase() }}
          </el-button>
        </div>
      </span>

    </el-dialog>

    <!--<h1><span>{{$t('login.title1')}}</span> {{$t('login.title1')}}</h1>-->
    <h1 v-html="$t('login.title')"></h1>
    <el-form :model="loginForm" :rules="rules" ref="loginForm" class="" :show-message=false>
      <el-form-item prop="username" :class="{ 'is-error': isErrorLogin }">
        <!--<el-popover
          ref="popover"
          placement="right"
          width="100%"
          trigger="hover"><img src="../../../static/img/Helper_Login_FR.png">
        </el-popover>-->
        <el-input v-model="loginForm.username" v-bind:placeholder="$t('login.username')" @change="clearError"
          v-on:keyup.enter.native="submitForm('loginForm')"><!--<i class="el-icon-question el-input__icon" slot="suffix" v-popover:popover></i>--></el-input>
      </el-form-item>
      <el-form-item prop="password" :class="{ 'is-error': isErrorLogin }">
        <el-input v-model="loginForm.password" v-bind:placeholder="$t('login.password')" type="password"
          @change="clearError" v-on:keyup.enter.native="submitForm('loginForm')"></el-input>
      </el-form-item>
      <div class="errorLogin">
        <span v-if="isErrorLogin">
          {{ this.msgErrorLogin }}
        </span>
      </div>
      <el-form-item>
        <div class="recCred col-24"><span @click="link('Recovery')">{{ $t('login.btn.recPassword') }}</span></div>
      </el-form-item>
      <el-form-item>
        <el-button v-on:keyup.enter="submitForm('loginForm')" @click="submitForm('loginForm')">{{ $t('login.btn.enter')
          }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button class="registrati" @click="link('Registrazione')">{{ $t('login.btn.reg') }} </el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { getTokenFCM } from '@/firebase'   // @ → src

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, trigger: 'blur' }
        ],
        password: [
          { required: true, trigger: 'blur' }
        ]
      },
      loginVisible: true,
      isErrorLogin: false,
      msgErrorLogin: '',
      showModalPwd: false,
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        newPwdRep: ''
      },
    }
  },
  i18n: {
    messages: {
      it_IT: {
        login: {
          title: '<span>Portale</span> Dipendenti',
          username: 'Username',
          password: 'Password',
          btn: {
            enter: 'Accedi',
            reg: 'Registrati',
            recPassword: 'Recupera Credenziali',
          },
          msg: {
            errLogin: 'Username o password errati',
            1286: 'Service temporairement indisponible pour maintenance, reessayez plus tard'
          },
          editPwd: 'Modifica Password',
          passwordTmp: 'Password Temporanea',
          passwordNew: 'Nuova Password',
          passwordRep: 'Conferma Password'
        }
      },
      en_GB: {
        login: {
          title: 'Employee <span>Portal</span>',
          username: 'Username',
          password: 'Password',
          btn: {
            enter: 'Enter',
            reg: 'Sign In',
            recPassword: 'Recover',
          },
          msg: {
            errLogin: 'Wrong username or password',
            1286: 'Service temporairement indisponible pour maintenance, reessayez plus tard'
          },
          editPwd: 'Change Password',
          passwordTmp: 'Temporary Password',
          passwordNew: 'New Password',
          passwordRep: 'Confirm Password'
        }
      },
      es_ES: {
        login: {
          title: '<span>Portal</span> de Trabajador',
          username: 'Usuario',
          password: 'Contraseña',
          btn: {
            enter: 'Acceso',
            reg: 'Registro',
            recPassword: 'Recuperar Contraseña',
          },
          msg: {
            errLogin: 'Nombre de usuario o contraseña incorrectos',
            1286: 'Service temporairement indisponible pour maintenance, reessayez plus tard'
          },
          editPwd: 'Es necesario crear una nueva contraseña antes de continuar',
          passwordTmp: 'Contraseña temporal',
          passwordNew: 'Nueva contraseña',
          passwordRep: 'Confirmar contraseña',
          insertMail: 'Introduce tu Email'
        }
      },
      fr_FR: {
        login: {
          title: '<span>Portail</span> des Employés',
          username: 'Identifiant',
          password: 'Mot de passe',
          btn: {
            enter: 'Accès',
            reg: 'Inscription',
            recPassword: 'Récupération',
          },
          msg: {
            errLogin: 'Mauvais nom d\'utilisateur ou mot de passe',
            1286: 'Service temporairement indisponible pour maintenance, reessayez plus tard'
          },
          editPwd: 'Changer le mot de passe',
          passwordTmp: 'Mot de passe provisoire',
          passwordNew: 'Mot de passe',
          passwordRep: 'Confirmer mot de passe',
          insertMail: 'Entrer votre Email'
        }
      },
      de_DE: {
        login: {
          title: '<span>Mitarbeiterportal</span>',
          username: 'Benutzer',
          password: 'Passwort',
          btn: {
            enter: 'Login',
            reg: 'Registrierung',
            recPassword: 'Passwort zurücksetzen',
          },
          msg: {
            errLogin: 'Falscher Benutzername oder Passwort',
            1286: 'Service temporairement indisponible pour maintenance, reessayez plus tard',
            1143: 'Dipendente non in forza',
            1173: 'Numero S.S. erronee ou salarie non inscrit',
            1114: 'Dipendente NON iscritto al servizio',
            1169: 'Attention vous avez depasse le nombre de tentative de connexion maximum : dans 48 heures vous recevrez une communication contenant votre nouveau mot de passe provisoire',
            1172: 'Mot de passe errone'
          },
          editPwd: 'Bevor weitergehen ist es notwendig ein neues Passwort einzurichten',
          passwordTmp: 'Vorläufiges Passwort',
          passwordNew: 'Neues Passwort',
          passwordRep: 'Passwort wiederholen',
          insertMail: 'Geben Sie Ihre E-Mail ein'
        }
      }
    }
  },
  beforeMount: function () {
  },
  mounted: function () {
  },
  methods: {
    submitForm: function (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          /*
          // 🔔 Richiedo permesso notifiche SOLO qui
          let token_notification = null;
          if (Notification.permission === "default") {
            try {
              const permission = await Notification.requestPermission();
              if (permission === "granted") {
                token_notification = await getTokenFCM();
                console.log("✅ Token FCM Browser:", token_notification);
              } else {
                console.warn("⚠️ Utente ha bloccato le notifiche");
              }
            } catch (err) {
              console.error("Errore notifiche:", err);
            }
          } else if (Notification.permission === "granted") {
            token_notification = await getTokenFCM();
            console.log("✅ Token FCM Browser:", token_notification);
          }*/

          //console.log('token_notification:'+token_notification)
          var obj = {
            j_username: this.loginForm.username.trim().toUpperCase(),
            j_password: this.loginForm.password,
            codLang: sessionStorage.getItem('codLang')
            //token_notification: token_notification // aggiungo qui il token
          }
          this.$http.post('noauth/portale/login', obj, { emulateJSON: true }).then(response => {
            if (response.status === 200) {
              // Verifico se la password è temporanea
              if (response.body.tempPwd === 'SI') {
                this.showModalPwd = true
                this.pwdForm.country = response.body.country
              } else {
                // Paramentri della Country
                this.setLang(response.body.country)
                this.$store.commit('set', { key: 'country', value: response.body.country })

                sessionStorage.setItem('token', response.body.wsToken)
                sessionStorage.setItem('token_download', response.body.wsTokenDownload)
                sessionStorage.setItem('tempPwd', response.body.tempPwd)
                sessionStorage.setItem('reqMail', response.body.email === '' ? 'SI' : 'NO')
                this.$store.commit('set', { key: 'lastAccess', value: response.body.lastAccess })
                this.$store.commit('set', { key: 'mail', value: response.body.email })
                this.$store.commit('set', { key: 'user', value: response.body.user })
                this.$store.commit('set', { key: 'nomex', value: response.body.nomex })
                this.$store.commit('set', { key: 'cognx', value: response.body.cognx })
                this.$store.commit('set', { key: 'societa', value: response.body.societa })
                this.$store.commit('set', { key: 'desSoc', value: response.body.desSoc })
                this.$store.commit('set', { key: 'tel1', value: response.body.tel1 })
                this.$store.commit('set', { key: 'localita', value: response.body.localita })
                // falg per la gestione della manutenzione programmata
                this.$store.commit('set', { key: 'prossimaManutenzione', value: response.body.prossimaManutenzione })

                this.$store.commit('set', { key: 'token_dtCreation', value: Math.round(Date.now() / 1000) })

                let obj = {
                  codiApp: '',
                  area: 'HOME',
                  tipologia: {
                    route: '',
                    desc: {
                      1: '',
                      2: '',
                      3: '',
                      4: '',
                      5: ''
                    },
                    codiCM: '',
                    codiCom: ''
                  }
                }
                this.$store.commit('set', { key: 'menu', value: obj })
                this.$router.push({ name: 'home' })
              }

            }
          }, response => {
            this.msgErrorLogin = response.body.msg[0].msgTxt //this.$i18n.t('login.msg.' + response.body.msg[0].msgId)
            this.isErrorLogin = true
            if (response.body.rc === 1) {
              if (response.body.attrib.alert !== undefined && response.body.attrib.alert === 'Y') {
                this.$message({
                  showClose: true,
                  message: this.msgErrorLogin,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            }
          })
        } else {
          this.isErrorLogin = true
          return false
        }
      })
    },
    clearError: function () {
      this.isErrorLogin = false
    },
    link: function (value) {
      this.$emit('link', value)
    },
    setLang: function (value) {
      let codLang = 'en_GB'
      if (value === '1') {
        codLang = 'it_IT'
      } else if (value === '2') {
        codLang = 'fr_FR'
      } else if (value === '3') {
        codLang = 'es_ES'
      } else if (value === '4') {
        codLang = 'fr_FR'
      } else if (value === '5') {
        codLang = 'de_DE'
      } else if (value === 'L') {
        codLang = 'fr_FR'
      }

      sessionStorage.setItem('codLang', codLang)
      this.$root.$i18n.locale = codLang
    },
    changePwd: function () {
      let correctInput = true
      if (this.pwdForm.oldPwd === '' || this.pwdForm.newPwd === '' || this.pwdForm.newPwdRep === '') {
        correctInput = false
        this.$message({
          message: 'Inserire tutti i dati',
          type: 'error'
        })
      }
      if (this.pwdForm.newPwd != this.pwdForm.newPwdRep) {
        correctInput = false
        this.$message({
          message: 'Le password non coincidono',
          type: 'error'
        })
      }
      if (correctInput) {
        var obj = {
          j_username: this.loginForm.username.trim().toUpperCase(),
          oldPwd: this.pwdForm.oldPwd,
          newPwd: this.pwdForm.newPwd,
          newPwdRep: this.pwdForm.newPwdRep,
          country: this.pwdForm.country,
          codLang: sessionStorage.getItem('codLang')
        }
        this.$http.post('noauth/setPwd', obj, { emulateJSON: true }).then(response => {
          if (response.body.rc === 0) {
            this.$message({
              message: response.body.msg[0].msgTxt,
              type: 'success'
            })
            this.showModalPwd = false
            this.loginForm.password = this.pwdForm.newPwd
            this.submitForm('loginForm')
          } else {
            this.$message({
              message: response.body.msg[0].msgTxt,
              type: 'error'
            })
          }
        })
      }
    },
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/WEB-style.less";

.LoginModulo {
  height: 500px;
  padding: 15px 15px;

  h1 {
    text-align: left;
    .set-font(@weight: 900, @size: 42px, @color: #fff);
    margin-bottom: 80px;

    span {
      .set-font(@weight: 300, @size: 42px, @color: #fff);
    }
  }

  .el-form-item {
    text-align: center;
    margin-bottom: 0;

    &.is-error {
      .el-input__inner {
        outline: #f56c6c solid 1px;
        outline: rgba(255, 0, 0, 0.9) solid 1px;
        outline-offset: 0px;
      }
    }

    .el-input {
      max-width: 300px;

      .el-input__inner {
        .set-font(@weight: 300, @size: 16px, @color: #000);
        display: block;
        margin: 10px auto;
        padding: 10px;
        max-width: 300px;
        border: 0;
        background-color: #fff;
        //background-color: rgba(255, 255, 255, .7);
        border: none;
        border-radius: 0px;

        // line-height: 0;
        &:focus {
          outline: #000 solid 1px;
          outline: rgba(0, 0, 0, .4) solid 1px;
          outline-offset: 0px;
        }
      }

      ::placeholder {
        color: #a2a2a2;
        font-style: italic;
      }
    }

    .el-button {
      width: 100%;
      .set-font(@weight: 300, @size: 16px, @color: #fff);
      background-color: #000;
      background-color: rgba(0, 0, 0, .6);
      font-weight: 300;
      margin-top: 50px;
      margin-bottom: 5px;
      transition: background-color .3s;
      border: 0;
      border-radius: 0;
      max-width: 300px;
      text-align: center;

      &:hover {
        background-color: #000;
        background-color: rgba(0, 0, 0, .8);
        cursor: pointer;
      }

      &:focus {
        outline: 0
      }
    }
  }

  .registrati {
    margin-top: 15px !important;
    background-color: transparent !important;
    color: #000 !important;
    border: 1px solid #000 !important;

    &:hover {
      background-color: #d5dde5 !important;
    }
  }

  .errorLogin {
    .set-font(@weight: 300, @size: 14px, @color: #d20e0e);
    //display: block;
    height: 22px;
    text-align: center;
  }

  .recCred {
    text-align: center;
    font-size: 15px;
    color: #fff;
    cursor: pointer;

    span {
      border-bottom: 1px solid #fff;
    }


  }

  &.mobile {
    h1 {
      text-align: left;
      .set-font(@weight: 900, @size: 24px, @color: #fff);
      margin-bottom: 40px;

      span {
        .set-font(@weight: 300, @size: 24px, @color: #fff);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue